import { AccountType } from './types';

// Payment type mapping for credits
export const PAYMENT_TYPE_MAP: Record<string, string> = {
  ADJ: 'Adjustment',
  CC: 'Credit Card',
  ADJUST: 'Adjustment',
  PAYPAL: 'PayPal',
  'Credit Card': 'Credit Card',
  Adjustment: 'Adjustment',
  ACH: 'Bank',
  Wire: 'Wire',
  Check: 'Check',
};

// Transaction types available for the add transaction form
export const TRANSACTION_TYPES = {
  PAYPAL: 'PayPal',
  'Credit Card': 'Credit Card',
  Adjustment: 'Adjustment',
  ACH: 'Bank',
  Wire: 'Wire',
  Check: 'Check',
} as const;

// Account Type Options
export interface AccountTypeOption {
  value: AccountType;
  label: string;
}

export const ACCOUNT_TYPE_OPTIONS: AccountTypeOption[] = [
  { value: 'BASIC', label: 'Basic' },
  { value: 'OLDLIMITED', label: 'Old Limited' },
  { value: 'DAILYCREDITS', label: 'Daily Credits' },
  { value: 'SUBSCRIPTION', label: 'Subscription' },
  { value: 'MONTHLYCREDITS', label: 'Monthly Credits' },
  { value: 'MONTHLYACCESS', label: 'Monthly Access' },
  { value: 'TRIAL', label: 'Trial' },
];
